<script lang="ts">
export default defineComponent({
	name: "OverviewSample"
});
</script>

<template>
	OverviewSample text
</template>

<style scoped lang="scss"></style>
